export default {"src":"/_next/static/media/open_gift.19d8273b.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};